@import "@/styles/variables";

.reviewCard {
	margin-top: 5px;
	background: white;
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 0 0 1px #e6e6e6;
	font-family: sans-serif;
	font-size: 14px;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 10px;

	.divHeader {
		display: flex;
		flex-direction: column;
		width: 25%;

		&.status {
			color: #e67e22;
			font-weight: 600;
			width: 10%;
		}

		h4 {
			margin: 0;
			font-weight: bold;
		}

		span {
			color: #999;
			font-size: 12px;
		}

		p {
			margin: 0;
			font-weight: 500;
		}
	}
}

.infoAlert {
	background: #f5faff;
	padding: 8px 0px;
	border-radius: 8px;
	margin-bottom: 6px;
	color: #333;
	font-size: 13px;

	.infoIcon {
		background: #6aad3d;
		color: white;
		border-radius: 50%;
		padding: 2px 6px;
		font-weight: bold;
		margin-right: 6px;
	}

	a {
		color: #1a73e8;
		text-decoration: underline;
		margin-left: 5px;
	}
}

.foundAlert {
	color: #6aad3d;
	font-weight: 600;
	margin-bottom: 8px;

	.count {
		background: #6aad3d;
		color: white;
		padding: 2px 6px;
		border-radius: 50%;
		margin-right: 4px;
		font-size: 12px;
	}
}

.similarList {
	border: 1px solid #eee;
	border-radius: 6px;
	overflow: hidden;
	margin-bottom: 20px;
}

.similarItem {
	display: flex;
	align-items: center;
	padding: 12px;
	border-top: 1px solid #eee;
	gap: 16px;

	&:first-child {
		border-top: none;
	}

	> div {
		flex: 1;
	}

	strong {
		display: block;
		font-size: 14px;
	}

	span {
		font-size: 12px;
		color: #777;
	}

	p {
		flex: 1;
		margin: 0;
	}
}

.match {
	background: #e6f5e9;
	color: #2e7d32;
	font-weight: bold;
	border-radius: 12px;
	padding: 4px 8px;
	font-size: 12px;
}

.eyeIcon {
	color: #999;
	cursor: pointer;
}

.useBtn {
	background: #7fb02f;
	color: white;
	border: none;
	border-radius: 6px;
	padding: 6px 10px;
	font-size: 13px;
	display: flex;
	align-items: center;
	gap: 6px;
	cursor: pointer;
}

.viewMore {
	text-align: center;
	padding: 10px;
	font-size: 13px;
	color: #666;
	cursor: pointer;
}

.confirmSection {
	border-top: 1px solid #eee;
	padding-top: 16px;

	p {
		font-size: 13px;
		color: #666;
	}
}

.divider {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: #999;
	font-size: 13px;
	margin-bottom: 4px;

	.divider_content {
		display: flex;
		flex-direction: row;
		gap: 1rem;

		> div {
			flex: 1;
		}

		.cancelButton {
			max-width: fit-content;
			max-height: fit-content;
			padding: 0.5em;
		}
	}
}

.confirmBtn {
	background: white;
	border: 1px solid #ccc;
	padding: 8px 12px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	gap: 6px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;

	&.reviewed {
		border-color: $primary-color;
		color: $primary-color;
	}
}

.reviewContainer {
	transition:
		opacity 0.3s ease,
		transform 0.3s ease,
		max-height 0.3s ease;
	overflow: hidden;
	will-change: transform, opacity;
}

.slideUpIn {
	opacity: 1;
	transform: translateY(0);
	max-height: 2000px;
}

.slideUpOut {
	opacity: 0;
	transform: translateY(-20px);
	max-height: 0;
}
